import { render, staticRenderFns } from "./VivaWalletSuccess.vue?vue&type=template&id=2051c586"
import script from "./VivaWalletSuccess.vue?vue&type=script&lang=js"
export * from "./VivaWalletSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports